<template>
  <el-dialog title="数据监控"
             :visible.sync="dialogVisible"
             :show-close="true"
             width="80%"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="form"
             :rules="rules"
             ref="refDialog"
             label-width="100px">
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item prop="profession"
                        label="行业">
            <el-select clearable
                       v-model="form.profession"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in platlists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>
    <!-- el-table -->

    <el-table v-loading="loading"
              border
              height="calc(100vh - 100px)"
              :data="tableData">
      <el-table-column :prop="item.label"
            v-for="(item, index) in tableTitle"
                       :key="index"
                       align="center"
                       header-align="center"
                       :label="item.name"></el-table-column>
    </el-table>
    <el-card v-if="total>0">
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
  </el-dialog>
</template>

<script>
import { dealReturn } from '@/common/js/index.js'
import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
export default {
  mixins: [getplatlists, getptnlists, getshoplists],
  name: 'ImportDialog',
  data() {
    return {
      dialogVisible: false,
      rules: {},
      form: {
        profession: '',
        business: '',
        store: '',
      },
      tableTitle: [],
      tableData: [
        {
          create_time: '2018-01-01',
          actFlag: 'T',
          platform_from: '天猫',
          cate: '美妆饰品',
          profession1: '美容护肤/美体/精油',
          profession2: '化妆水/爽肤水',
          profession3: '化妆水/爽肤水',
          profession4: '化妆水/爽肤水',
          profession5: '化妆水/爽肤水',
          profession6: '化妆水/爽肤水'
        }
      ],
      queryPrdlists: {
        pagenum: 1,
        pagesize: 20
      },
      total: 0,
      rules: {
        profession: [{ required: true, message: '必填项', trigger: 'blur' }],
        business: [{ required: true, message: '必填项', trigger: 'blur' }],
        store: [{ required: true, message: '必填项', trigger: 'blur' }],
      },
      loading: false,
    }
  },
  created() {
    
  },
  methods: {
    show() {
      this.getList()
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
      this.form = { profession: '', business: '', store: '' }
    },
    async getList() {
      let query = {
        url: 'DataMonitor',
        title: '列表',
        method: 'post'
      }
      let parm = {
        "reportname": this.$route.name
      }
      this.loading = true
      let { data, err } = await this.axiosApi(
        query,
        parm
      )
      this.loading = false

      if (data && data.data.meta.status === 200) {
        console.log(data.data, 'data1')
        this.tableData = data.data.data.data
        this.tableTitle = data.data.data.title
        this.total = 0
      } else {
        dealReturn(data, err)
      }
    },
    handleSizeChange() {},
    handleCurrentChange() {},
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/maijia/maijiaDatamoint/index.vue